import { render } from "./NewsVisitsTable.vue?vue&type=template&id=02b8c465"
import script from "./NewsVisitsTable.vue?vue&type=script&lang=js"
export * from "./NewsVisitsTable.vue?vue&type=script&lang=js"

import "./NewsVisitsTable.vue?vue&type=style&index=0&id=02b8c465&lang=sass"

import exportComponent from "D:\\a\\1\\s\\Vind\\VindBack\\VindBackVueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable});
